import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from 'react-simple-dropdown';
import theme from 'theme/theme';

const StyledDropdown = styled(({ pullRight, ...other }) => <Dropdown {...other} />)`
  &.dropdown {
    position: relative;
    &:hover {
      cursor: pointer;
    }
  }
  
  .dropdown__trigger {
    display: inline-block;
    text-decoration: none;
  }
  
  .dropdown__content {
     display: none;
     position: absolute;
     z-index: 20;
     min-width: 100%;
     ${(props) => props.pullRight && css`
      right: 0;
     `};
     padding: 5px 10px;
     background: ${(props) => props.background};
     box-shadow: ${theme.shadows.default};
     @media (min-width: ${theme.breakpoints.desktopLarge}) {
       padding: 15px 30px;
     }
  }
  
  &.dropdown--active .dropdown__content {
     display: block;
  }
`;
StyledDropdown.propTypes = {
  pullRight: PropTypes.bool,
  background: PropTypes.string,
};
StyledDropdown.defaultProps = {
  pullRight: false,
  background: theme.colors.white,
};


const DropdownLink = styled.div`
  line-height: 1rem;
  margin-bottom: 0.75rem;
  &:hover {
    color: ${theme.colors.primary}
  }
`;


export default StyledDropdown;


export {
  DropdownContent,
  DropdownTrigger,
  DropdownLink,
};
